import {
  Bolt as BoltIcon,
  Link as LinkIcon,
  MenuBook as MenuBookIcon,
} from '@mui/icons-material';
import { pagePaths } from 'routes/paths';

export type CoreDictionaryId = 'words' | 'irregular' | 'expressions';

export interface CoreDictionaryMeta {
  id: CoreDictionaryId;
  en: string;
  /** Compact Ukrainian label shown on the /vocabulary hub card. */
  name: string;
  desc: string;
  Icon: typeof MenuBookIcon;
  accent: string;
  to: string;
}

/**
 * Static metadata for the three "core" vocabulary sections. The BE only ships
 * per-section counts (vocabularyName + totals) — everything used to render
 * the spotlight card (English label, color, icon, target route, description,
 * compact display name) lives here, indexed by position in the
 * `store.common.vocabulary.data` array which is fixed at:
 *   0 = Words, 1 = Irregular verbs, 2 = Expressions.
 */
export const CORE_META: CoreDictionaryMeta[] = [
  {
    id: 'words',
    en: 'Words',
    name: 'Слова',
    desc: 'Окремі слова, які ти зберігаєш під час навчання.',
    Icon: MenuBookIcon,
    accent: '#3B2C93',
    to: '/' + pagePaths.vocabularyWords,
  },
  {
    id: 'irregular',
    en: 'Irregular verbs',
    name: 'Неправильні дієслова',
    desc: 'Три форми дієслів, що не підкоряються правилу -ed.',
    Icon: BoltIcon,
    accent: '#3B2C93',
    to: '/' + pagePaths.vocabularyVerbs,
  },
  {
    id: 'expressions',
    en: 'Expressions',
    name: 'Словосполучення',
    desc: 'Фрази, словосполучення та ідіоми, що звучать «як носій».',
    Icon: LinkIcon,
    accent: '#3B2C93',
    to: '/' + pagePaths.vocabularyExpressions,
  },
];
